import {PayloadAction} from "@reduxjs/toolkit"
import {Reducer} from "react"
import {ScheduledShipment} from "../../shared/entities/Order/ScheduledShipment";

export type ScheduledShipmentState = {
    list: { items: Array<ScheduledShipment>, count: number },
}
const State: ScheduledShipmentState = {
    list: {
        items: [],
        count: 0
    }
}

export enum ActionTypes {
    SCHEDULED_SHIPMENT_ALL = "SCHEDULED_SHIPMENT_ALL",
    CLEAR_ALL = "CLEAR_ALL",
}

export const ScheduledShipmentReducer: Reducer<ScheduledShipmentState, PayloadAction<any>> = (state = State, action: PayloadAction<any>): ScheduledShipmentState => {
    switch (action.type) {
        case ActionTypes.SCHEDULED_SHIPMENT_ALL:
            return state = {...state, list: action.payload}
        case ActionTypes.CLEAR_ALL:
            return {...state, list: {items: [], count: 0}};
        default:
            return state;
    }
}


